/**
 * ERROR TRACKING (sentry.io)
 * https://docs.sentry.io/error-reporting/quickstart
 */
import * as Sentry from '@sentry/vue';
import type { App as VueApp } from 'vue';

export function initSentry(
  app: VueApp,
  dsn?: string,
  environment?: string,
  options?: any,
): void {
  if (dsn) {
    Sentry.init({
      app,
      environment,
      dsn,
      integrations: [],
      beforeSend: options?.beforeSend,
      beforeBreadcrumb: options?.beforeBreadcrumb,
    });
  }
}
